// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sQOI","left":"styles_left__wOF6O"};